import { attr, FASTElement, observable } from '@microsoft/fast-element';
import { SwatchRGB } from '../../color';
import { brand, designTokens } from '../../design-tokens';
import { paletteStyles } from './palette.styles';
import { paletteTemplate } from './palette.template';
import { CSSDesignToken, DesignToken, DesignTokenChangeRecord, DesignTokenSubscriber } from '../../foundation/design-token';
import { NatGenDesignSystem } from '../../natgen-design-system';

/**
 * @element natgen-palette
 */
export class NatGenPalette extends FASTElement implements DesignTokenSubscriber<DesignToken<any>> {
    connectedCallback(): void {
        super.connectedCallback();

        brand.subscribe(this);
        this.setPalette();
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();

        brand.unsubscribe(this);
    }

    @attr
    color: string;
    colorChanged(previousValue: string, nextValue: string) {
        this.setPalette();
    }

    setPalette() {
        const colorTokenGroup = `color-${this.color}`
        let tokenKeys = Object.keys(designTokens).filter(key => key.startsWith(colorTokenGroup));
        this.palette = tokenKeys.map(key => [key.substring(colorTokenGroup.length + 1), (designTokens[key].token.getValueFor(this) as SwatchRGB).toColorString()]);
    }

    target: string;

    @observable
    palette: [string, string][] = [];

    handleChange(_: CSSDesignToken<any>, record: DesignTokenChangeRecord<DesignToken<any>>): void {
        console.log(record);
        this.setPalette();
    }
}

export const natGenPaletteDefinition = NatGenPalette.compose({
    name: `${NatGenDesignSystem.prefix}-palette`,
    template: paletteTemplate(),
    styles: paletteStyles
});
